module.exports = __webpack_public_path__ + "img/live7.0ee44c2f.jpg";